import { configureStore } from "@reduxjs/toolkit";
import authReducer from './authSlice';
import appReducer from './appSlice';
import ordersReducer from './orderSlice';
import userReducer from './userSlice';
import settingReducer from './settingSlice';
import notifyReducer from './notifySlice';
import officeReducer from './officeSlice';
import staticReducer from './staticSlice';
import advertReducer from './advertSlice';


export const store = configureStore({
    reducer: {
        auth: authReducer,
        app: appReducer,
        orders: ordersReducer,
        users: userReducer,
        settings: settingReducer,
        office: officeReducer,
        static: staticReducer,
        advert: advertReducer,

        notify: notifyReducer,
    }
});

window.store = store;